export function fillResponsiveValues<T>(arr: T[], max: number): T[] {
  if (arr.length === 0) {
    return [];
  }
  if (arr.length === 1) {
    return fillResponsiveValues([...arr, ...arr], max);
  }
  if (arr.length < max) {
    return fillResponsiveValues([...arr, arr[arr.length - 1]], max);
  }
  if (arr.length > max) {
    return arr.slice(0, max);
  }
  return arr;
}

export type CalculateResponsiveValuesParams = {
  slidesToShow: number | number[];
  centered: boolean | boolean[];
  breakpoints: number[];
};

export type ResponsiveValues = {
  slidesToShow: number;
  centered: boolean;
};

export function calculateResponsiveValues({
  slidesToShow,
  centered,
  breakpoints,
}: CalculateResponsiveValuesParams): ResponsiveValues {
  const responsiveSlidesToShow = fillResponsiveValues(
    typeof slidesToShow === 'number' ? [slidesToShow] : slidesToShow,
    breakpoints.length,
  );

  const responsiveCentered = fillResponsiveValues(
    typeof centered === 'boolean' ? [centered] : centered,
    breakpoints.length,
  );

  let breakPointIndex: number = breakpoints.length;
  if (window) {
    breakPointIndex = [0, ...breakpoints].reduce(
      (acc, breakpoint, index) => (window.innerWidth >= breakpoint ? index : acc),
      0,
    );
  }

  return {
    slidesToShow: responsiveSlidesToShow[breakPointIndex - 1] ?? responsiveSlidesToShow[0],
    centered: responsiveCentered[breakPointIndex - 1] ?? responsiveCentered[0],
  };
}
